export default __webpack_public_path__ + "static/media/img_base_green.4cc166ca.jpg";